// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltips_tooltip__7SxN-","title":"Tooltips_title__2I3b7","content":"Tooltips_content__2a3wT"};